
import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Input, Select, message, Modal, DatePicker } from "antd";
import { UseFetchListEnum } from "../../../../hooks/useFetchEnums";
import { ENUM_TYPE,JOB_TYPE,USER_ROLE } from "../../../../data/constant";
import dayjs from "dayjs";
import { handlePasteImage, formatImageBase64 } from "../../../../function/pasteImage";
import { UseFetchListUser } from "../hooks/useFetch";

const HolidayModal = ({
    visible,
    onCancel,
    onOk,
    record,
    loading = false
}) => {
    const [editForm] = Form.useForm();
    const { mutateAsync: FetchListEnum } = UseFetchListEnum();
    const { mutateAsync: FetchListUser } = UseFetchListUser();
    const [holidayTypeOptions, setHolidayTypeOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [imageSrc, setImageSrc] = useState([]);
    const textareaRef = useRef(null);

    useEffect(() => {
        callAPI();
    }, [record, visible, editForm]);

    // Sync imageSrc with form field value for validation if needed
    useEffect(() => {
        editForm.setFieldValue("images", imageSrc.length > 0 ? "has-images" : "");
    }, [imageSrc, editForm]);

    const callAPI = async () => {
        try {
            const payloadEnum = {
                enumType: [ENUM_TYPE.holiday_type],
            }
            const payloadUser = {
                jobType: [JOB_TYPE.panel_output],
                userRole: [USER_ROLE.employee],
                enable: true
            }
            const result = await FetchListEnum(payloadEnum);
            const resultUser = await FetchListUser(payloadUser);
            setHolidayTypeOptions(result);
            setUserOptions(resultUser);
        } catch (error) {
            message.error('ไม่สามารถดึงข้อมูลได้');
        }
    }

    const handleSubmit = async () => {
        try {
            const values = await editForm.validateFields();

            // Format images if needed to send to API
            const formattedImages = imageSrc.map((image) => formatImageBase64(image));

            const payload = {
                date: dayjs(values.selectDate).format('YYYY-MM-DD'),
                note: values.note,
                holidayType: values.holidayType,
                img: formattedImages, 
                employeeId: values.selectUser
            }
            onOk(payload);
            editForm.resetFields();
            setImageSrc([]); // Reset images
        } catch (error) {
            console.log(error);
            message.error('ไม่สามารถอัพเดตข้อมูลได้');
        }
    };

    const handleCancel = () => {
        editForm.resetFields();
        setImageSrc([]); // Reset images
        onCancel();
    };

    const onPaste = (event) => {
        handlePasteImage(event, (result) => {
            setImageSrc((prev) => [...prev, result]);
        });
    };

    return (
        <Modal
            title="เพิ่มวันหยุด"
            open={visible}
            onOk={handleSubmit}
            onCancel={handleCancel}
            width={800}
            okText="บันทึก"
            cancelText="ยกเลิก"
            confirmLoading={loading}
        >
            <Form form={editForm} layout="vertical">
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <Form.Item name="holidayType" label="สาเหตุการลา" style={{ width: '30%' }}>
                        <Select
                            options={holidayTypeOptions}
                            placeholder="เลือกสาเหตุ"
                            allowClear
                        />

                    </Form.Item>
                    <Form.Item name="selectDate" label="วันที่">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item name="selectUser" label="พนักงาน" style={{ width: '25%' }}>
                        <Select
                            options={userOptions}
                            placeholder="เลือกพนักงาน"
                            allowClear
                        />
                    </Form.Item>
                </div>

                <Form.Item
                    name="images"
                    label="รูปภาพ(receipt)"
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <div>
                        <textarea
                            ref={textareaRef}
                            placeholder="กด Ctrl+V เพื่อวางรูป"
                            onPaste={onPaste}
                            rows={2}
                            style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                            }}
                        />
                        {imageSrc.length > 0 && (
                            <>
                                <div className="mt-2 mb-1">
                                    <strong>Preview รูป:</strong>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "10px",
                                    }}
                                >
                                    {imageSrc.map((src, index) => (
                                        <div
                                            key={index}
                                            style={{ width: "100px", position: "relative" }}
                                        >
                                            <Button
                                                type="text"
                                                danger
                                                style={{
                                                    position: "absolute",
                                                    top: -10,
                                                    right: -10,
                                                    padding: 0,
                                                    minWidth: "20px",
                                                    height: "20px",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "white",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                }}
                                                onClick={() => {
                                                    const newImageSrc = [...imageSrc];
                                                    newImageSrc.splice(index, 1);
                                                    setImageSrc(newImageSrc);
                                                }}
                                            >
                                                ×
                                            </Button>
                                            <img
                                                src={src}
                                                alt="pasted"
                                                style={{
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </Form.Item>

                <Form.Item name="note" label="หมายเหตุ">
                    <Input.TextArea rows={4} placeholder="Enter Note" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default HolidayModal; 